module.exports = __webpack_public_path__ + "img/logo.da2a0f18.png";